var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"tw-flex tw-flex-col tw-bg-white tw-p-5 tw-min-h-[1px]"},[_c('article',{class:_vm.childClasses},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }